import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { SessionService } from './services/session.service';

export function trimStringsInPayload(value: unknown): unknown {
  if (typeof value === 'string') {
    return value.trim();
  }

  if (Array.isArray(value)) {
    return value.map(item => trimStringsInPayload(item));
  }

  if (
    value !== null
    && typeof value === 'object'
    && Object.getPrototypeOf(value) === Object.prototype
  ) {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, trimStringsInPayload(item)])
    );
  }

  return value;
}

@Injectable()
export class RequestInterceptor {
  constructor(private sessionService: SessionService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (['POST', 'PUT', 'PATCH'].includes(request.method) && request.body !== null) {
      request = request.clone({
        body: trimStringsInPayload(request.body),
      });
    }

    if (request.url.includes('loyale.io')) {
      const nextHeaders: Record<string, string> = {
        'X-Frame-Options': 'DENY',
      };

      // Allow callers to provide a custom Authorization header (e.g. Cube JWT for reports-agent endpoints).
      const token = this.sessionService.token;
      if (!request.headers.has('Authorization') && token) {
        nextHeaders['Authorization'] = `Bearer ${token}`;
      }

      request = request.clone({ setHeaders: nextHeaders });

      if (this.sessionService.schemeId && !request.headers.has('X-Scheme')) {
        request = request.clone({
          setHeaders: {
            'X-Scheme': this.sessionService.schemeId,
          }
        });
      }

      return next.handle(request);
    } else {
      return next.handle(request);
    }
  }
}
